import { ITaxStatus } from 'src/app/store/user/facade/user.facade';
import { ViewProfileState, initialViewProfileState } from './../user/reducers/user.view.reducer';
import { FeatureFlagsState, initialFeatureFlagsState } from '../feature-flags/reducers/feature-flags-reducer';
import { InvitationState, initialInvitationState } from '../user/reducers/invitations.reducer';
export interface IUserState {
  viewProfile: ViewProfileState;
  featureFlags: FeatureFlagsState;
  invitation: InvitationState
}

export const initialUserState: IUserState = {
  viewProfile: initialViewProfileState,
  featureFlags: initialFeatureFlagsState,
  invitation: initialInvitationState
};